export default __webpack_public_path__ + "static/media/sentro_logomark.9a413635.png";